// Author: Magnus s195401 & Erik s195397
import { Clear } from "@mui/icons-material";
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { FunctionComponent } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { PartnerType } from "types/partners/PartnerTypes";
import { formatCents } from "util/money";

type PropsType = {
  partner: PartnerType;
  onEdit: () => void;
  onDelete: () => void;
};
// Partner Row
const PartnerRow: FunctionComponent<PropsType> = ({
  partner,
  onEdit,
  onDelete,
}) => {
  return (
    <>
      <TableRow>
        <TableCell sx={{ paddingLeft: "20px" }}>
          {partner?.info.firstName ? partner?.info.firstName : "Intet Navn"}{" "}
          {partner.info.lastName ? partner.info.lastName : " "}
        </TableCell>
        <TableCell>{partner.info?.phone || " No phone "}</TableCell>
        <TableCell>
          {<a href={"mailto: " + partner?.info.email}>{partner.info.email}</a>}
        </TableCell>
        <TableCell>{partner.info?.company || "Not defined"}</TableCell>
        <TableCell>{partner.info?.street || "Not defined"}</TableCell>
        <TableCell>{partner.serviceDescription || "—"}</TableCell>
        {/* EE-240: values from the partner's newest inquiry; the amounts are
            øre since EE-253, and blank until that inquiry was priced. */}
        <TableCell>
          {partner.lastItemsTotalCents != null
            ? formatCents(partner.lastItemsTotalCents)
            : "—"}
        </TableCell>
        <TableCell>
          {partner.lastTransportCostCents != null
            ? formatCents(partner.lastTransportCostCents)
            : "—"}
        </TableCell>
        <TableCell>{partner.lastDeliveryTime || "—"}</TableCell>
        <TableCell>
          {partner.lastNotes ? (
            <Tooltip title={partner.lastNotes}>
              <span
                style={{
                  display: "block",
                  maxWidth: "220px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {partner.lastNotes}
              </span>
            </Tooltip>
          ) : (
            "—"
          )}
        </TableCell>
        <TableCell>
          <IconButton
            disabled={false}
            title="Rediger"
            color={"primary"}
            size="small"
            onClick={onEdit}
          >
            <EditIcon />
          </IconButton>

          <IconButton
            title="Slet"
            color={"primary"}
            size="small"
            onClick={onDelete}
          >
            <Clear />
          </IconButton>
        </TableCell>

        <TableCell></TableCell>
      </TableRow>
    </>
  );
};

export default PartnerRow;
